import zh from './zh.ts'
import en from './en.ts'
import ja from './ja.ts'
import Russian from './russian.ts'
import Malay from './malay.ts'

export const messages = {
    zh,
    en,
    ja,
    Russian,
    Malay
}

export default messages 